export default __webpack_public_path__ + "static/media/design-letters.b2708baf.svg";